import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  FileTextOutlined,
  PictureOutlined,
  TagOutlined,
  SettingOutlined,
  InfoCircleOutlined,
  LinkOutlined,
  FileOutlined,
  SearchOutlined,
  HomeOutlined,
  HeartOutlined,
  StarOutlined,
  LockOutlined,
  UnlockOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  MinusOutlined,
  CheckOutlined,
  CloseOutlined,
  QuestionCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';

export interface IconOption {
  name: string;
  component: React.ComponentType<any>;
}

export const ICON_LIST: IconOption[] = [
  { name: 'UserOutlined', component: UserOutlined },
  { name: 'MailOutlined', component: MailOutlined },
  { name: 'PhoneOutlined', component: PhoneOutlined },
  { name: 'EnvironmentOutlined', component: EnvironmentOutlined },
  { name: 'CalendarOutlined', component: CalendarOutlined },
  { name: 'ClockCircleOutlined', component: ClockCircleOutlined },
  { name: 'FileTextOutlined', component: FileTextOutlined },
  { name: 'PictureOutlined', component: PictureOutlined },
  { name: 'TagOutlined', component: TagOutlined },
  { name: 'SettingOutlined', component: SettingOutlined },
  { name: 'InfoCircleOutlined', component: InfoCircleOutlined },
  { name: 'LinkOutlined', component: LinkOutlined },
  { name: 'FileOutlined', component: FileOutlined },
  { name: 'SearchOutlined', component: SearchOutlined },
  { name: 'HomeOutlined', component: HomeOutlined },
  { name: 'HeartOutlined', component: HeartOutlined },
  { name: 'StarOutlined', component: StarOutlined },
  { name: 'LockOutlined', component: LockOutlined },
  { name: 'UnlockOutlined', component: UnlockOutlined },
  { name: 'EyeOutlined', component: EyeOutlined },
  { name: 'EyeInvisibleOutlined', component: EyeInvisibleOutlined },
  { name: 'EditOutlined', component: EditOutlined },
  { name: 'DeleteOutlined', component: DeleteOutlined },
  { name: 'PlusOutlined', component: PlusOutlined },
  { name: 'MinusOutlined', component: MinusOutlined },
  { name: 'CheckOutlined', component: CheckOutlined },
  { name: 'CloseOutlined', component: CloseOutlined },
  { name: 'QuestionCircleOutlined', component: QuestionCircleOutlined },
  { name: 'ExclamationCircleOutlined', component: ExclamationCircleOutlined }
];

export const getIconComponent = (iconName: string) => {
  const iconOption = ICON_LIST.find(icon => icon.name === iconName);
  return iconOption ? iconOption.component : UserOutlined;
};

export const getIconName = (iconName: string) => {
  return iconName || 'UserOutlined';
};
